import { render } from "./red-envelop.vue?vue&type=template&id=21129696&scoped=true&ts=true"
import script from "./red-envelop.vue?vue&type=script&lang=ts"
export * from "./red-envelop.vue?vue&type=script&lang=ts"

import "./red-envelop.vue?vue&type=style&index=0&id=21129696&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21129696"]])

export default __exports__